import React from "react"
import styled from "styled-components"
interface content_props {
  text?: string
  numberColor: string
}

export function Content({ text, number, numberColor }: any) {
  // const formatedNumber = number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  const parts = number.toString().split(".")
  const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  const formatedNumber =
    parts.length > 1 ? `${formattedInteger}.${parts[1]}` : formattedInteger

  return (
    <ContentDiv numberColor={numberColor} text={text}>
      <div className="text">{text}</div>
      <p className="number">${formatedNumber}</p>
    </ContentDiv>
  )
}

export const ContentDiv = styled.div<content_props>`
  /* min-width: 56px; */
  text-transform: uppercase;
  margin: 0 10px;
  z-index: 1;
  padding-left: ${({ text }) => (text === "solar" ? "6px" : "0")};
  @media only screen and (min-width: 400px) {
    padding-left: ${({ text }) =>
      text === "solar" ? "0px" : "0"}; //TODO refactor
  }
  @media only screen and (min-width: 1024px) {
    padding: 6px 0;
    margin: 0 10px 0 12px;
  }
  .number {
    background: ${({ numberColor }) => numberColor};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`

interface cube_props {
  color: string
  winner: boolean
}

export const Container = styled.div<cube_props>`
  position: relative;
  display: flex;
  align-items: center;
  margin: 10px 0;
  min-width: 80px;
  /* height: 32px; */
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  color: ${({ color }) => color};
  animation: ${({ winner }) => (winner ? " blink 0.6s infinite" : "")};
  margin-bottom: 14px !important;
  @keyframes blink {
    0%,
    50%,
    100% {
      opacity: 1;
    }
    25%,
    75% {
      opacity: 0.5;
    }
  }
  /* padding-left: 10px; */
  @media only screen and (min-width: 350px) {
    min-width: 88px;
    font-size: 14px;
    margin: 15px 0;
  }
  @media only screen and (min-width: 400px) {
    font-size: 16px;
  }
  @media only screen and (min-width: 768px) {
    min-width: 124px;
    /* height: 40px; */
    margin: 15px 15px 10px;
    font-size: 17px;
    :first-of-type {
      min-width: 102px;
    }
  }
  @media only screen and (min-width: 1024px) {
    margin: 0;
    font-size: 18px;
    :first-of-type {
      min-width: 124px;
    }
  }
`

export const Cube = styled.div`
  margin-left: -10px;
  height: 36px;
  z-index: 1;
  img {
    width: 30px;
    height: 36px;
  }
  @media only screen and (min-width: 375px) {
    img {
      width: 34px;
    }
  }
  @media only screen and (min-width: 400px) {
    height: 40px;
    img {
      width: 38px;
      height: 40px;
    }
  }
  @media only screen and (min-width: 768px) {
    height: 42px;
    img {
      width: 44px;
      height: 46px;
      margin-top: -2px;
    }
  }
  @media only screen and (min-width: 1024px) {
    height: 48px;
    img {
      height: 50px;
    }
  }
`
export const BackgroundDiv = styled.div<{ background: string }>`
  width: 100%;
  height: 100%;
  background: ${({ background }) => "linear-gradient(" + background + ")"};
  z-index: 1;
  position: absolute;
  opacity: 0.7;
  box-shadow: inset 0px 0px 5.86593px rgba(205, 159, 17, 0.3);
  border-radius: 4.91335px;
`
